import { EInterventionStatus } from '@enums/intervention.enum';
import { ESurveyEntryPoint } from '@enums/survey.enum';

export const qualitySurveyFieldId = {
  commitment: 'commitment',
  communication: 'communication',
  followUpRequested: 'followUpRequested',
  hasScheduledEndDate: 'hasScheduledEndDate',
  openFeedback: 'openFeedback',
  overallSatisfaction: 'overallSatisfaction',
  quality: 'quality',
  scheduledEndDate: 'scheduledEndDate',
  speed: 'speed',
} as const;

export type InterventionSatisfactionAspect =
  | 'commitment'
  | 'communication'
  | 'quality'
  | 'speed';

export const interventionSatisfactionAspects: Array<InterventionSatisfactionAspect> =
  ['communication', 'commitment', 'speed', 'quality'];

export const interventionSatisfactionWithoutQualityAspects =
  interventionSatisfactionAspects.filter(aspect => aspect !== 'quality');

export const nonQualityInterventionStatuses = new Set<string>([
  EInterventionStatus.Lost,
  EInterventionStatus.NoCost,
  EInterventionStatus.Trashed,
]);

export const excludedInterventionStatuses = new Set<string>([
  EInterventionStatus.Trashed,
]);

export const satisfactionOptionsValues: Record<ESurveyEntryPoint, string> = {
  [ESurveyEntryPoint.VerySatisfied]: '4',
  [ESurveyEntryPoint.Satisfied]: '3',
  [ESurveyEntryPoint.Unsatisfied]: '2',
  [ESurveyEntryPoint.VeryUnsatisfied]: '1',
};

export const satisfactionOptions = [
  {
    icon: 'star-eyes',
    labelKey: 'survey.option.very_satisfied',
    value: satisfactionOptionsValues[ESurveyEntryPoint.VerySatisfied],
  },
  {
    icon: 'smile',
    labelKey: 'survey.option.satisfied',
    value: satisfactionOptionsValues[ESurveyEntryPoint.Satisfied],
  },
  {
    icon: 'frown',
    labelKey: 'survey.option.unsatisfied',
    value: satisfactionOptionsValues[ESurveyEntryPoint.Unsatisfied],
  },
  {
    icon: 'angry',
    labelKey: 'survey.option.very_unsatisfied',
    value: satisfactionOptionsValues[ESurveyEntryPoint.VeryUnsatisfied],
  },
] as const;

export const openFeedbackMaxLength = 1000;
